export default function GetInTouch(){
    return(
        <>
            <h6 className="widget-title text-white pb-15 mb-35">Get In Touch</h6>
            <address className="address-box">
                <span>2307 Beverley Rd</span>
                <span>Brooklyn, New York 11226</span>
                <span>United States.</span>
            </address>
            <address>
                <span><b className="text-white">Open:</b> Monday to Saturday</span>
                <span>From 7h to 18h or talk to an expert</span>
                <span>0712-0610-3314 – available 24/7</span></address>
        </>
    )
}